/**
 * Browser translation (Google Translate, built into iOS Chrome and the Google app) replaces text
 * nodes React owns with <font> elements. React later removes or inserts next to a node that is
 * no longer where it left it, the DOM throws, and the error boundary takes the page down
 * (BOOK-4049, facebook/react#11538). Skip those operations instead of throwing: the worst case
 * is a stale piece of translated text left on screen.
 */
export const guardTranslatedDom = () => {
    // eslint-disable-next-line @typescript-eslint/unbound-method -- always invoked with .call(this)
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
        if (child.parentNode !== this) return child;
        return originalRemoveChild.call(this, child) as T;
    };

    // eslint-disable-next-line @typescript-eslint/unbound-method -- always invoked with .call(this)
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(
        this: Node,
        node: T,
        child: Node | null
    ): T {
        if (child && child.parentNode !== this) return node;
        return originalInsertBefore.call(this, node, child) as T;
    };
};
